import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

export const showConfirmSweetAlert = async (options) => {
  try {
    const result = await Swal.fire(options);
    return result;
  } catch (error) {
    throw error;
  }
};

export const showSuccessSweetAlert = async (options) => {
  console.log("options", options);
  await Swal.fire({
    title: options?.title,
    text: options?.text,
    icon: "success",
    showCloseButton: true,
    showCancelButton: false,
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
  });
  /* Swal.fire({
    title: options.message,
    icon: "success",
    draggable: true

  }); */
};
